<template>
	<splash v-show="isLoading" title="진단평가 준비중..." />
	<splash v-show="isProc" title="잠시만 기다려 주세요." />
	<!-- <introEval /> -->
	<q-layout view="hHh lpR fFf" min-width="800px">
		<q-header unelevated class="bg-white" heighproblemt-hint="198">
			<q-toolbar elevated class="color_gray_900">
				<div class="display_flex go-home">
					<q-icon
						name="img:/assets/images/icon/icon_home.svg"
						:onclick="onHome"
					/>
					<!-- <q-icon name="img:/assets/images/icon/icon_home.svg" :onclick="onHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" /> -->
					<!-- <img :src="require(`../../../public/assets/images/icon/icon_home.svg`)" /> -->
					<!-- <span class="mg_left_24 b1 medium line_height_45">진단평가</span> -->
					<span class="mg_left_24 b1 medium line_height_45"
						>진단평가 {{ isTTTestKReadiD ? gStore.platform : '' }}</span
					>
					<!-- <span class="mg_left_24 medium line_height_28"> {{ isLog ? KreadIDForLog : '' }} </span> -->
					<q-input
						v-if="isTTTestKReadiD"
						outlined
						v-model="tttestKReadid"
						placeholder="KRT_E2_1350_N_05"
						@keyup.enter="onReturnTttestKreaeId"
					>
					</q-input>
					<CusButton
						v-if="isTTTestKReadiD"
						:type="160"
						:label="`Go`"
						@onReturn="onReturnTttestKreaeId"
						style="width: 50px"
					/>
				</div>
				<div class="display_flex timer">
					<p class="caption1 medium line_height_28">풀이 시간</p>
					<p
						class="mg_left_16 h1 bold color_gray_600 line_height_48"
						:class="isTimeOver ? 'color_red' : 'color_normal'"
					>
						{{ estimatedTimeStr }}
					</p>
				</div>
			</q-toolbar>
			<q-linear-progress
				size="3px"
				:value="progressPercent"
				style="color: #18b73f"
			/>
		</q-header>

		<q-page-container>
			<q-page
				class="q-pa-md"
				style="height: calc((var(--vh, 1vh) * 100) - 150px); position: relative"
			>
				<FloatingBtn
					:visible="showBtnNext"
					@on-click="onClickNext"
					class="answer--next"
				/>
				<FloatingBtn
					:visible="showBtnResult"
					text="최종 제출하기"
					text-only="true"
					bgColor="black"
					@on-click="onClickResult"
					bottom="calc( 20vh - 55px )"
					class="answer--submit"
				/>
				<div class="row">
					<div class="col passage">
						<!-- <q-scroll-area id="scroll"> -->
						<qbankHeaderVue
							:questionHeader="questionHeader"
							@isChangeHeader="onReturnIsChangeHeader"
						/>
						<!-- </q-scroll-area> -->
					</div>

					<div class="col answer">
						<!-- <qbankProblem :p-content="problem" v-if="tab === item.index" @setCheckedAnswer="setCheckedAnswer"
                            @onChangeProblems="onChangeProblems" @setProblemResult="setProblemResult" /> -->
						<q-scroll-area
							ref="scrollAreaRef"
							visible
							style="height: 100%"
							class="answer__scroll"
						>
							<div style="margin: 0.7vw 0 0 0">
								<ProblemChoiceEval
									v-if="problem"
									:p-content="problem"
									:unit-no="unitNo"
									:isStudy="isStudy"
									@setAnswer="setAnswer"
								/>
								<ProblemChoiceEval2
									v-if="problem && isTTTestKReadiD"
									:p-content="problem"
									:unit-no="unitNo"
									:isStudy="isStudy"
									@setAnswer="setAnswer"
								/>
							</div>
							<div>
								<solutionEval :p-content="problem" v-if="visibleAnswer" />
							</div>
						</q-scroll-area>
					</div>
				</div>
			</q-page>
		</q-page-container>
	</q-layout>

	<modal-layer v-if="showResultPop" width="30rem">
		<div
			align="center"
			style="
				height: 400px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				text-align: center;
			"
		>
			<img src="@/assets/images/logo.png" /><br /><br />
			<span style="color: #ef5724; font-weight: bold; font-size: 40px">
				{{ levelLessonStr }}
			</span>
			<br /><br />
			<q-btn
				size="lg"
				style="width: 200px"
				class="q-mt-sm text-h6"
				color="primary"
				@click="onGoToLogin"
				type="submit"
				label="로그인하기"
			/>
		</div>
	</modal-layer>
</template>

<script setup>
// import { historyBack } from '@/helpers/utils';
import splash from '@/components/template/splash.vue';
// import introEval from '@/views/eval_login/EvalIntro.vue';
import { ref, onMounted, onUnmounted, watch, computed, toRaw } from 'vue';
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
// import qbankHeaderVue from '@/views/eval_qbank/components/header_eval.vue';
import qbankHeaderVue from '@/components/qbank/header.vue';

import ProblemChoiceEval from '@/views/eval_qbank/components/problemChoice_eval.vue';
import ProblemChoiceEval2 from '@/views/eval_qbank/components/problemChoice_eval2.vue';
// import problemChoice from '@/components/qbank/problemChoice.vue';
// import qbankAnswer from '@/views/paper/eval/qbankAnswer_eval.vue'
import solutionEval from '@/views/eval_qbank/components/solution_eval.vue';
import AnswerMarking from '@/components/qbank/answerMarking.vue';
// import studyHeader from '@/components/layouts/header/studyHeader.vue';
// import wordCahrt from '@/components/chart/wordCahrt.vue';
import { getKrtExam, getKrtProblem } from '@/api/modules/qbank';
import {
	getExam,
	getUnit,
	apiGetOmrList,
	apiSendEachUnit,
	apiSendFinalResult,
} from '@/api/modules/eval_api.js';
import {
	exam,
	getNumber,
	getCorrectNo,
	setDeviceVersion,
	headerQbankWithNo,
	showDialog,
	showErrorNoData,
	showErrorConnection,
} from '@/views/eval_qbank/exam_common.js';
// import timerCheck from '@/views/eval_qbank/timerCheck.js';
import dataToParse from '@/helpers/qbankParser/dataParse';

import CusButton from '@/components/widget/CusButton.vue';
import {
	getHeaderTitle,
	getKreadScore,
	getHeaderText,
	getEtcInfo,
	getHeader,
} from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import moment from 'moment';
import { soundEffect, soundTic } from '@/helpers/soundEffect';
import { StudyStore } from '@/store/modules/study';
import { useRouter, useRoute } from 'vue-router';
import cqBtn from '@/components/quasar/cqBtn.vue';
import _ from 'lodash';
import ProblemRelation from '@/components/qbank/problemRelation.vue';
import { analysis, difficult, drill } from '@/helpers/qbankParser/qbankMeta';
import { postAnswer } from '@/api/modules/study';
import { postUserJson } from '@/api/modules/login';
import { getAnswer } from '@/helpers/qbankParser/qbankDataParse';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import FloatingBtn from '@/components/quasar/floatingBtn.vue';

import {
	monitoringLog,
	monitoringEndDiagnosticStudy,
} from '@/api/modules/monitoring';

const isLog = ref(true);
const isLog2 = ref(false);
const isTTTestKReadiD = ref(false);
const tttestKReadid = ref('KRT_E2_1350_N_05'); //   KRT_E2_1350_N_05  KRT_E2_1550_L_01

const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const questionHeader = ref(null);
let problem = ref(null);
const scrollAreaRef = ref(null);

const isChangeHeader = ref(false);
////////////////////////////----ttta_진단평가 시작----////////////////////////////
const isLoading = ref(true);
const isProc = ref(null);
const isEval = ref(gStore.evalData.is_eval);
// const isStudy = ref(gStore.evalData.is_study);
const isStudy = ref(false);

let arrProblemID = {};
let curUnit = {};
const unitNo = ref(0);
let omr = [];
const curSel = ref(-1); // 선택한 보기번호

const showBtnPrev = ref(false);
const showBtnNext = ref(false);
const showBtnResult = ref(false);
let showResultPop = ref(false);

const minKread = 1200;
const maxKread = 1600;
const levelLessonStr = ref();

// 진단평가 결과
let idxLevLes = 0;
let arrRecommend = [];

//////////////////----유저_답안지----///////////////////
const uKRead = ref(gStore.evalData.start_kread); // 등급에 따른 시작크리드 점수, 유저 현재 크리드점수
let kreadID = '';
const KreadIDForLog = ref();

const getGradeFromID = kreadID => kreadID.slice(4, 6);
const getKreadFromID = kreadID => kreadID.slice(7, 11);
const getLiteratureFromID = kreadID => kreadID.slice(12, 13);
const getTopicFromID = kreadID => kreadID.slice(14, 16);
const isMMM = unitNo1 => unitNo1 < 10; // 처음 문학3지문
const isNo3 = unitNo1 => unitNo1 % 3 === 0;

const visibleAnswer = ref(false);

//////////////////----시험지----///////////////////
const getExamData = async (param, nextNo) => {
	const examData = await getExam(param);
	// if (showTestLog.value) console.log(`--examData:  `, examData);

	if (examData)
		if (examData.status === 200) {
			// problemID 가져오기
			arrProblemID = examData.data.data.examMaps[examData.data.data.examIds[0]];
			if (isLog.value)
				console.log(`-getExamData-arrProblemID:  `, arrProblemID);
			const index = isMMM(nextNo)
				? nextNo - 1
				: isNo3(nextNo)
				? 2
				: (nextNo % 3) - 1;
			const problem = isMMM(nextNo)
				? arrProblemID[nextNo - 1]
				: arrProblemID[index];

			if (isLog.value)
				console.log(`-getExamData-nextNo1:${nextNo}  index:${index} `, problem);

			// 문항 가져오기
			const resUnit = await getUnit({
				version: gStore.version_eval,
				problemId: problem.problemId,
			});
			if (resUnit)
				if (resUnit.status === 200) curUnit = resUnit; // setCurUnit
				else showDialogGoToLogin(resUnit.message);
			else showDialogGoToLogin('u통신 오류:');
		} else showDialogGoToLogin(examData.message);
	else showDialogGoToLogin('e통신 오류:');
};

////----시험지_화면에_삽입----////
const injectExam = () => {
	const headerHtml = getHeader(curUnit.data.data);
	// if (showTestLog.value)const headerHtml = getHeader(curUnit.data.data,true);
	const size = omr.length;
	const nextNo = size === 36 ? size : size + 1;

	questionHeader.value = headerQbankWithNo(headerHtml, nextNo); //  지문상단에 번호 삽입
	problem.value = curUnit.data; // 문제 삽입
	if (isLog2.value)
		console.warn(
			`-- 정답 ✅✅✅✅✅✅✅ :`,
			curUnit.data.data.content.solution.answer.detail[0]
		);
	// if (showTestLog.value)console.log('--injectExam-  problem.value', problem.value);
	unitNo.value = nextNo; // 표시될 문제 넘버링
	if (isTTTestKReadiD.value) unitNo.value = initNextNo++;
	if (isLog.value)
		console.log(
			`--injectExam--useOmr.length:${omr.length} unitNo.value:`,
			unitNo.value,
			omr
		);

	// 초기화
	curSel.value = -1;
	// showBtnNext.value = !(size === 36);
	showBtnResult.value = size === 36;

	KreadIDForLog.value = kreadID;
	if (isLog2.value) console.warn(`-- KREAD ID 🅿️🅿️ :`, kreadID);

	// scrollUp();
	isProc.value = false;
};

// const scrollUp = () => {
//     const el = document.getElementById('scroll');
//     const scrollEl = el.getElementsByClassName('scroll')[0];
//     const offset = el.offsetTop;
//     setVerticalScrollPosition(getScrollTarget(scrollEl), offset, 0);
// };

const getKreadID = (grade, kread, literature, topic) => {
	kreadID = `KRT_${grade}_${kread}_${literature}_${topic}_01`;
	if (isLog2.value) console.warn(`--<<<<< 다음크리드ID >>>>>--:  `, kreadID);
	return kreadID;
};

const createTopic = nextNo =>
	(isMMM(nextNo) ? 0 : Math.ceil(nextNo / 3) - 3).toString().padStart(2, '0');

const getNextKRead = uKRead1 => {
	const resultKRead = Math.floor(uKRead1 / 50) * 50; // 50단위로 (필수?)
	return getMinMaxCheck(resultKRead); // 최소값 최대값 바운더리 체크
};

const getMinMaxCheck = digit => {
	// min max check
	if (digit < minKread) return minKread;
	if (digit > maxKread) return maxKread;
	return digit;
};

////----reply보내기----////
const send1Answer = async unitNo1 => {
	if (isLog.value) console.log(`-send1Answer-unitNo1:  `, unitNo1);
	const param = createParam(unitNo1);
	if (isLog.value) console.log(`--createParam:  `, unitNo1, param);
	const res = await apiSendEachUnit(gStore.is_member_eval, param);
	if (res)
		if (res.status === 200) {
			omr.push(param); // 완료 후 useOmr에 삽입.
			if (isLog.value) console.log(`--reply   omr:  `, omr);

			return true;
		} else {
			// 답변정보 중복
			if (res.data.statusCode === '848') {
				//중복난것이 마지막가 아니라면 이어 풀기처리 하고
				if (unitNo.value !== 36) {
					await getInitOmr();
				} else {
					//마지막을 경우 패스해야함 마지막 중복은 그냥 최종전달 되도록 처리
					return true;
				}
			}
		}
	return false;
};
const createParam = curNo => {
	const correctNo = getCorrectNo(
		curUnit.data.data.content.solution.answer.detail
	);
	const isRight = Number(curSel.value) === Number(correctNo);
	const weightSeed = curUnit.data.data.content.property.analysis.analysisId;
	const weightP = Number(weightSeed === 5077 || weightSeed === 5078 ? 3 : 2); // 사실, 추론
	const difficultySeed =
		curUnit.data.data.content.property.analysis.difficultCd;
	const difficultyP = Number(
		difficultySeed === '05' ? 1 : difficultySeed === '04' ? 0.5 : 0
	);
	// const calculatedTime = timeSec.value * 1000 - totalElapsedTimeMilli;
	// totalElapsedTimeMilli = timeSec.value * 1000;
	const calculatedTime = timeSec.value - totalElapsedTimeMilli;
	totalElapsedTimeMilli = timeSec.value;
	// if (isLog.value) console.log(`--calculatedTime:  `, calculatedTime);
	// if (isLog.value) console.log(`--timeSec:${timeSec.value} totalElapsedTime:${totalElapsedTimeMilli}  `, calculatedTime);

	const param = {
		exprSyncVersion: curUnit.data.data.content.version, // 시험지version
		examName: kreadID, // 현재 시험지ID
		// problemOrd: curNo, // 문제번호
		problemOrd: getValidProblemOrd(curNo), // 문제번호
		problemId: getValidProblemId(curNo), // 문항ID
		// problemId: curUnit.data.data.content.problemId, // 문항ID
		// correct: correctNo, // 정답
		correct: getValidBogey(correctNo), // 정답
		answer: getValidBogey(curSel.value), // 제출한 답
		// answer: curSel.value === 1 || curSel.value === 2 || curSel.value === 3 || curSel.value === 4 || curSel.value === 5 ? curSel.value : router.go(router.currentRoute), // 제출한 답
		correctYn: isRight, // 채점 boolean
		elapsedTime: calculatedTime, // 지금문제 푼 시간 millisecond
		// cumulativeTime: timeSec.value * 1000, // 현재까지 경과시간 millisecond
		cumulativeTime: timeSec.value, // 현재까지 경과시간 millisecond
		studentKreadScore: getResultCalculate(curNo, isRight, weightP, difficultyP), // 이번 문제까지의 점수 (주의:3문제 단위로 산정됨)
		weight: weightP, // 가중치 점수.
		difficulty: difficultyP, // 난이도 점수.
		reviewContents: isChangeHeader.value
			? document.getElementById('header_box').innerHTML
			: null, // :  지문(하이라이트) 저장
		// reviewContents: questionHeader.value, // :  지문(하이라이트) 저장
		examKreadScore: Number(curUnit.data.data.content.property.header.etcTxt03), // 지문KReaD 점수
	};
	return param;
};

const getValidProblemOrd = _curNo => {
	const result = _curNo === omr.length + 1 ? _curNo : null;
	if (isLog.value) console.log(`- getValidProblemOrd-result  : `, result);
	if (result) return result;
	router.go(router.currentRoute);
};
const getValidBogey = noData => {
	const result =
		noData === 1 || noData === 2 || noData === 3 || noData === 4 || noData === 5
			? noData
			: null;
	if (isLog.value) console.log(`- getValidBogey-result  : `, result);
	if (result) return result;
	router.go(router.currentRoute);
};

// 현재의 ID와 시험지의 문제ID와 일치여부 체크
const getValidProblemId = curNo => {
	const index =
		curNo < 10
			? curNo - 1
			: curNo % 3 === 0
			? (curNo % 3) + 2
			: (curNo % 3) - 1;
	if (isLog.value)
		console.log(`- getValidProblemId-curNo , index012 : `, curNo, index);

	const examProblemId = arrProblemID[index].problemId;
	const unitProblemId = curUnit.data.data.content.problemId;
	if (isLog.value)
		console.log(
			`- getValidProblemId-examId, unitId, isNotSame : `,
			examProblemId,
			unitProblemId,
			examProblemId !== unitProblemId
		);
	if (examProblemId !== unitProblemId) router.go(router.currentRoute); // problemId 불일치
	return unitProblemId;
};

//////////////////----점수계산----/////////////////// 4444
const getResultCalculate = (curNo, isRight, weightP, difficulty) => {
	// uKRead.value = uKRead.value + getKreadAmount(curNo, isRight, weightP, difficulty);
	const currentKread = Number(getKreadFromID(kreadID)) || uKRead.value;
	const calAmount = getKreadAmount(curNo, isRight, weightP, difficulty);
	uKRead.value = currentKread + calAmount;
	if (isLog2.value)
		console.warn(
			`-문${curNo}-현재점수:uKRead.value  `,
			currentKread,
			calAmount,
			uKRead.value
		);
	return uKRead.value;
};

// 가중치계산
const getKreadAmount = (curNo, isRight, weightP, difficulty) => {
	let cPoint = 0;
	let result = 0;

	if (isMMM(curNo)) {
		if (isLog.value) console.log(`--getKreadAmount  isMMM curNo:${curNo} :`);
		if (curNo === 9) {
			omr.map(u1 => {
				cPoint =
					cPoint +
					getPoints(
						curNo,
						u1.problemOrd,
						u1.correctYn,
						u1.weight,
						u1.difficulty
					);
			});
			cPoint = cPoint + getPoints(curNo, ' ', isRight, weightP, difficulty); // 현재문제
			// plus Kread 점수 가져오기.
			if (cPoint < 6) result = -100;
			if (6 <= cPoint && cPoint < 11) result = -50;
			if (11 <= cPoint && cPoint < 17) result = 0;
			if (17 <= cPoint && cPoint < 22) result = 50;
			if (22 <= cPoint) result = 100;
			if (isLog2.value) console.warn(`--포인트${cPoint} 가감:`, result);
		}
		return result;
	} else {
		// if (showTestLog.value) console.log(`--getKreadAmount  else curNo:${curNo} :`);
		if (isNo3(curNo)) {
			const u1 = omr[curNo - 3]; // 문1
			cPoint =
				cPoint +
				getPoints(curNo, u1.problemOrd, u1.correctYn, u1.weight, u1.difficulty);
			const u2 = omr[curNo - 2]; // 문2
			cPoint =
				cPoint +
				getPoints(curNo, u2.problemOrd, u2.correctYn, u2.weight, u2.difficulty);
			cPoint = cPoint + getPoints(curNo, ' ', isRight, weightP, difficulty); // 문3(현재문제)

			// if (showTestLog.value) console.warn(`-문${curNo})  가중치:${cPoint}, 채점:`, result);

			if (cPoint < 5) result = -50;
			if (5 <= cPoint && cPoint < 6.5) result = 0;
			if (6.5 <= cPoint) result = 50;
			if (isLog2.value) console.warn(`--포인트:${cPoint}   가감:`, result);
		}
		return result;
	}
};

const getPoints = (curNo, problemOrd, isRight, weightP, difficulty) => {
	const result = isRight ? weightP + difficulty : 0;
	if (isLog2.value)
		console.warn(
			`-Cur${curNo}_문${problemOrd}) 채점:${
				isRight ? 'O' : 'X'
			}  가중치:${weightP} 난이도:${difficulty} 점수:${result}`
		);
	return result;
};
//////////////////----onclick----///////////////////
const onPrevUnit = () => {};
const onNextUnit = async () => {
	isProc.value = true;
	showBtnNext.value = false;

	if (isTTTestKReadiD.value) {
		const nextNo = unitNo.value + 1;
		if (nextNo > 9 && isNo3(nextNo - 1)) {
			// 다음 시험지ID 만들기
			const grade = nextNo > 9 ? 'E2' : 'E1';
			const kread = getNextKRead(uKRead.value);
			const literature = nextNo > 15 ? 'N' : 'L';
			const topic = createTopic(nextNo);
			getKreadID(grade, kread, literature, topic);
		}
		// console.log('-onNextUnit--kreadID---', kreadID);
		const param = { version: gStore.version_eval, examNm: kreadID };
		await getExamData(param, nextNo); // param , 가져올 문제번호
		injectExam();
		isProc.value = false;
		return;
	}
	if (!(unitNo.value === 36 && omr.length === 36)) {
		const result = await send1Answer(unitNo.value);
		if (isLog.value) console.log(`--send1Answer  - result-:`, result);
		if (!result) {
			isProc.value = false;
			return;
		}
	}
	if (unitNo.value === 36) {
		//중복문제가 발생된 상태에서는 send를하지 않음
		showBtnNext.value = false;
		clearInterval(timeInterval);
	} else {
		const nextNo = unitNo.value + 1;
		if (isLog.value) console.log(`--send1Answer  - nextNo-:`, nextNo);

		if (nextNo > 9 && isNo3(nextNo - 1)) {
			// 다음 시험지ID 만들기
			const grade = nextNo > 9 ? 'E2' : 'E1';
			const kread = getNextKRead(uKRead.value);
			const literature = nextNo > 15 ? 'N' : 'L';
			const topic = createTopic(nextNo);
			getKreadID(grade, kread, literature, topic);
		}

		// console.log('-onNextUnit--kreadID---', kreadID);
		const param = { version: gStore.version_eval, examNm: kreadID };
		await getExamData(param, nextNo); // param , 가져올 문제번호
		injectExam();
	}
	isProc.value = false;
};

////----보기클릭_답안지배열에_넣기----////
const setAnswer = val => {
	if (unitNo.value === 36) showBtnResult.value = true;
	else showBtnNext.value = true;

	curSel.value = getNumber(val); // 찍은 번호 기억
};

const onHome = () => {
	// showTestLog.value = !showTestLog.value;
	dStore.openSelect('진단평가를 중단하고<br/> 이동하시겠습니까?', val => {
		if (gStore.is_member_eval) val && router.push('/learninghome');
		else val && router.push('/eval-login');
	});
};

const onGoToLogin = () => {
	// showResultPop.value = false;
	// 초기화
	// gStore.initUserData();
	router.push('/login');
};

//////////////////----최종 레벨레슨 계산----///////////////////
const onFinish = async () => {
	showBtnResult.value = false;
	await onNextUnit();
	isProc.value = true;
	const arrCorrect = omr.filter(e => e.correctYn); // 맞은 문제 arr
	if (isLog2.value)
		console.log(`--맞은 문제 arr-${arrCorrect.length}-:`, arrCorrect);

	// if (arrCorrect.length < 4) setLevLesStr(0); // 3문제 이하면 최하등급 확정.
	// else {
	// 갈래별 분리, 정답있는 갈래만 add to arrResultKreads
	const chunk = getDivide(omr, 3); // 3지문씩 나누기
	const arrResultKreads = []; // 정답인 문제있으면 지분 전체의 문제 KREAD 넣기  int only
	for (const arrP of chunk) {
		for (const p of arrP) {
			if (p.correctYn) {
				addCorrectedQuestion(arrResultKreads, arrP);
				break;
			}
		}
	}
	if (isLog2.value)
		console.log(
			`--유저점수 도출할 Kread 문제 개수-${arrResultKreads.length}-:`,
			arrResultKreads
		);

	// arr내의 평균값 구하기.
	const sum = arrResultKreads.reduce((sum, current) => sum + current, 0);
	let average =
		arrResultKreads.length < 1 ? 1200 : sum / arrResultKreads.length;
	// let average = arrResultKreads.reduce((sum, current) => (Math.floor(sum) + current) / 2);
	if (isLog2.value)
		console.log(`--위의 average:${average}  uKread:${uKRead.value}--:`);
	// average = average < 1200 ? 1200 : average > 1600 ? 1600 : average;
	uKRead.value = Math.round(average); // 최종 유저크리드 점수 대입.
	if (isLog.value) console.log(`--  uKread:${uKRead.value}--:`);

	idxLevLes = getLevLesIndex(average);
	if (isLog.value) console.log('--setResultStr-idxLevLes:', idxLevLes);

	// 추천학습 해당되는 갈래 arr (총6종)
	arrRecommend = getArrRecomm();
	let countRecommend = 0;
	arrRecommend.forEach(bool => {
		if (bool) countRecommend++;
	});
	if (isLog.value) console.log('---countRecommend  :', countRecommend);

	// 1레벨1레슨 =추천학습 없음, 추천학습 4종 이상이면 1단계 아래 + 추천학습 없음(모두 false)
	if (countRecommend > 3 || idxLevLes === 0) {
		idxLevLes = getDownIdx(idxLevLes);
		arrRecommend = [false, false, false, false, false, false];
		if (isLog.value) console.log('---추천학습 해당사항:', arrRecommend);
	}
	setLevLesStr(idxLevLes);

	// 결과전송
	sendResultData(arrRecommend);
};

// 진단평가 최종결과값 전송
const sendResultData = async arrRecommend => {
	const finalParam = {
		kreadScore: uKRead.value,
		elapsedTime: timeSec.value,
		level: levelObj[idxLevLes].level,
		lesson: levelObj[idxLevLes].lesson,
		recommendation: [...arrRecommend],
	};

	if (isLog.value) console.log('--sendResultData-finalResult- :', finalParam);

	const resResult = await apiSendFinalResult(finalParam);

	showBtnResult.value = true;
	if (isLog.value) console.log('--전송결과-resResult- :', resResult);
	if (resResult)
		if (resResult.status === 200) {
			if (isLog.value)
				console.log('--전송결과-resResult-resResult.status === 200 :');
			showBtnResult.value = false;

			//k.u.j 성장판 2.0 오늘의 학습 api call
			monitoringEndDiagnosticStudy({
				eventTypeCode: 1,
			});

			setTimeout(() => {
				router.push('/eval-report');
			}, 500);
		}
		// showResultPop.value = true; //  성공 메세지
		else showDialogGoToLogin(resResult.message);
	else showDialogGoToLogin('r통신 오류:');
};

const setLevLesStr = index => {
	const levles = levelObj[index];
	// console.log('--setResultStr-index:', index);
	if (isLog.value) console.warn('--setResultStr-결과값 레벨레슨:', levles);
	levelLessonStr.value = `${levles.level}레벨 ${levles.lesson}레슨`;
};

const getDownIdx = levObjIdx => {
	switch (levObjIdx) {
		case 0:
			return 0;
		case 5:
		case 6:
			return 3;
		default:
			return levObjIdx - 1;
	}
	// (levObjIdx === 0 ? 0 : levObjIdx - 1);
};

//추천학습에 해당하는 토픽리스트 11:현대시 12:고전시가 13:고전산문
const getArrRecomm = () => {
	const arrTopicsStr = [];
	arrTopicsStr.push(isNotPassRecommend(0, 6));
	arrTopicsStr.push(isNotPassRecommend(6, 9));
	arrTopicsStr.push(isNotPassRecommend(15, 6));
	arrTopicsStr.push(isNotPassRecommend(21, 6));
	arrTopicsStr.push(isNotPassRecommend(27, 6));
	arrTopicsStr.push(isNotPassRecommend(33, 3));
	if (isLog.value) console.warn('--getArrRecomm-  추천학습 arr:', arrTopicsStr);

	return arrTopicsStr;
};

// 추천학습에 통과하지 못한 토픽인지
const isNotPassRecommend = (start, size) => {
	let count = 0;
	for (let i = start; i < start + size; i++) {
		if (omr[i]?.correctYn) count++;
	}
	const percent = (count / size) * 100;
	return percent < 51;
};

// 하나라도 맞춘 것, 토픽 전체문제 넣기 => arr
const addCorrectedQuestion = (arrBucket, arr) => {
	arr.forEach(e => {
		arrBucket.push(Number(e.examKreadScore));
	});
};

// chunk
const getDivide = (arr, size) => {
	const result = [];
	let i = 0;
	while (i < arr.length) {
		result.push(arr.slice(i, i + size));
		i += size;
	}
	return result;
};

const levelObj = [
	{ level: 1, lesson: 1 },
	{ level: 1, lesson: 49 }, // : 프리버전은 49레슨 없음
	{ level: 2, lesson: 1 },
	{ level: 2, lesson: 49 }, // : 프리버전은 49레슨 없음
	{ level: 3, lesson: 1 },
	{ level: 3, lesson: 1 }, // : 프리버전용
	{ level: 3, lesson: 1 }, // : 프리버전용
];

const getLevLesIndex = average => {
	if (isLog2.value) console.log('--getlevelstr average--', average);

	let index = 0;
	if (1200 <= average && average < 1350) index = 0;
	if (1350 <= average && average < 1400) index = 1;
	if (1400 <= average && average < 1450) index = 2;
	if (1450 <= average && average < 1500) index = 3;
	if (1500 <= average && average < 1550) index = 4;
	if (1550 <= average && average < 1600) index = 5;
	if (1600 <= average) index = 6;
	return index;
};
//////////////////--------///////////////////

const showDialogGoToLogin = msg => {
	if (isLog.value) console.warn('--showDialogGoToLogin--errorMsg:', msg);
	// store.openConfirmDialog({
	//     // title: '평가 중단하기',
	//     // message: `${msg} 로그인페이지로 이동합니다.`,
	//     message: `${msg}`,
	//     cancel: '닫기',
	//     ok: '확인',
	//     callback: (val) => {
	//         if (gStore.is_member_eval) val && router.push('/login');
	//         else val && router.push('/eval-login');
	//     },
	// });
};

//////////////////----시간로직_프로그레스----///////////////////
const estimatedTimeStr = ref('00:00');
let isTimeOver = false;

const progressPercent = computed(() => {
	return (unitNo.value * 100) / 36 / 100; // 진단평가 진행도 표시
});
const progressClassColor = ref('progressNormal');

const timeSec = ref(0);
let totalElapsedTimeMilli = 0;

watch(timeSec, newTimeSec => {
	if (newTimeSec >= 3600) isTimeOver = true;
	progressClassColor.value = isTimeOver ? 'progressWarn' : 'progressNormal';
});

const currentMil = () => Math.floor(new Date().getTime() / 1000);
let startTimeMil = currentMil();
const timeStr = no => no.toString().padStart(2, '0');
let timeInterval;
const startTimeCount = () => {
	timeInterval = setInterval(() => {
		// console.log('--setInterval-currentTimeMillis-', currentMil());
		// console.log('--setInterval-startTimeMil-', startTimeMil);
		timeSec.value = currentMil() - startTimeMil;
		// console.log('--setInterval-timeSec.value-', timeSec.value);
		// timeSec.value =estimatedSec
		// timeSec.value = timeSec.value > 0 ? estimatedSec : timeSec.value + estimatedSec;
		if (omr.length === 36 || isTTTestKReadiD.value) clearInterval(timeInterval);
		// ++timeSec.value;
		const hour_ = timeSec.value % 3600;
		const min = Math.floor(timeSec.value / 60);
		const sec = hour_ % 60;
		estimatedTimeStr.value = `${timeStr(min)}:${timeStr(sec)}`;
	}, 1000);
};
const onReturnTttestKreaeId = () => {
	// console.log('onReturnTttestKreaeId------', route.path);
	// router.go(router.currentRoute);
	checkAndStart();
};
////////////////----ttttttz----////////////////
onMounted(async () => {
	isLoading.value = true;
	if (isLog.value) console.log('currentRoute- -----', route.path);
	if (route.path === '/evaltest3') {
		isTTTestKReadiD.value = true;
		isLog.value = true;
	}

	setDeviceVersion();

	if (!gStore.token_eval)
		router.push(gStore.is_member_eval ? '/login' : '/eval-login');
	initKreadExam(); // 시험지 초기화
	await getInitOmr(); // 이어풀기 가져오기
	checkAndStart(); //

	let data = {
		menuName: route.path.split('/').join(''),
	};
	monitoringLog(data, res => {
		console.log('eval_qbank monitoringLog API response ===', res);
	});
	if (
		process.env.NODE_ENV === 'local' ||
		process.env.NODE_ENV === 'development' ||
		localStorage.getItem('videoSuperPass')
	) {
		visibleAnswer.value = true;
	}
});

const initKreadExam = () => {
	// 초기화
	kreadID = '';
	curSel.value = -1;
	uKRead.value = gStore.evalData.start_kread;
	unitNo.value = 0;

	// 초기 시험지ID 만들기
	const grade = 'E1';
	const kread = gStore.evalData.first_kread;
	const literature = 'L';
	const topic = '00';
	getKreadID(grade, kread, literature, topic);
	// console.log('-initKreadExam--kreadID---', kreadID);
};
/**
 * 이어풀기 가져오기
 */
const getInitOmr = async () => {
	const res = await apiGetOmrList();
	if (res && res.status === 200) {
		// gStore.setEvalRealGrade()  //비회원은 이어풀기시 실제학년정보가 필요함.
		const before = res.data.data;
		// console.log('-getInitOmr-  res--', res);
		if (before && before.length > 0) {
			const pre = res.data.data.map(e => {
				return {
					...e,
					problemOrd: Number(e.problemOrd),
					problemId: Number(e.problemId),
					correct: Number(e.correct),
					answer: Number(e.answer),
					elapsedTime: Number(e.elapsedTime),
					cumulativeTime: Number(e.cumulativeTime),
					studentKreadScore: Number(e.studentKreadScore),
					weight: Number(e.weight),
					difficulty: Number(e.difficulty),
				};
			});
			// 번호순으로 sorting
			omr = pre.sort((a, b) => {
				return a.problemOrd - b.problemOrd;
			});
			if (isLog.value) console.log('--getInitOmr-omr-', omr);
		}
	}
};
let param, initNextNo;
const checkAndStart = async () => {
	const size = omr.length;
	/* 1-1 기존 데이터가 있을 경우 */
	if (size > 0) {
		////////////////////////--이어풀기-- //////////////////////// 3의배수의 다음수일때는 크리드 점수 계산하여 kread 다시 만들어야.
		const lastOmr = omr.find(e => {
			return e.problemOrd === omr.length;
		});

		// 진단평가 최초로그인 시 받은 버전으로 고정.
		gStore.setVersionForEval(lastOmr.exprSyncVersion);

		// 학년을 잘못 선택한 경우를 대비하여 store에 다시 세팅. 학년 때문에. (의미없음-이어풀기는 이미 학년고정됨)
		const userGrade = omr[0].examName.slice(7, 9); // M1 M2 M3
		gStore.setEvalStudentGradeCode(userGrade);
		gStore.setEvalStartKread(
			userGrade === 'M1'
				? 1300
				: userGrade === 'M2'
				? 1400
				: userGrade === 'M3'
				? 1500
				: 1300
		); // 1300 1400 1500
		if (isLog.value) console.log('--checkAndStart evalData:', gStore.evalData);
		uKRead.value = lastOmr.studentKreadScore; // 유저의 현재까지 점수 세팅.

		initNextNo = size === 36 ? size : size + 1;
		const needNewExam = initNextNo > 9 && initNextNo % 3 === 1;
		if (needNewExam) {
			// 다음 시험지ID 만들기
			const grade = initNextNo > 9 ? 'E2' : 'E1';
			const kread = getNextKRead(uKRead.value);
			const literature = initNextNo > 15 ? 'N' : 'L';
			const topic = createTopic(initNextNo);
			getKreadID(grade, kread, literature, topic);
			// 다음 시험지 잘 받아오는지 테스트할 것.  재로그인하여 이어풀기.  reply 성공여부 확인 할 것.   : mypage 지식맵  api 확인 할 것.
			// console.log('-onNextUnit--kreadID---', kreadID);
			param = { version: lastOmr.exprSyncVersion, examNm: kreadID };
		} else {
			kreadID = lastOmr.examName;
			param = { version: lastOmr.exprSyncVersion, examNm: lastOmr.examName };
		}
		//// 경과 시간 세팅
		totalElapsedTimeMilli = omr.reduce(
			(before, current) => before + current.elapsedTime,
			0
		); // 누적시간 계산
		if (isLog2.value)
			console.log(`--initEval--  총 누적시간:`, totalElapsedTimeMilli);
		timeSec.value = totalElapsedTimeMilli;
	} else {
		/* 1-2 처음인 경우 */
		initNextNo = 1;
		param = { version: gStore.version_eval, examNm: kreadID };
	}
	/* 2. 진단평가 시작 */
	// ttttest333333   KRT_E2_1350_N_05  KRT_E2_1550_L_01
	if (isTTTestKReadiD.value) {
		initNextNo = 10; // 첫3지문 건너뛰기.
		kreadID = tttestKReadid.value + '_01';
		if (isLog2.value) console.log(`--getKreadID 수동조정-kreadID-:`, kreadID);
		param = { version: gStore.version_eval, examNm: kreadID };
	}

	await getExamData(param, initNextNo); // param, 가져올 문제번호
	injectExam();
	setTimeout(() => {
		isLoading.value = false;
		// if (showTestLog.value) console.log('--start timeSec.value--', timeSec.value);

		// 시작시간 세팅 : 기존 값에 따라 분기.
		startTimeMil =
			totalElapsedTimeMilli > 0
				? currentMil() - totalElapsedTimeMilli
				: currentMil();
		if (isLog.value) console.log(`--initEval-- startTimeMil:`, startTimeMil);

		startTimeCount();
	}, 1000);
};
const onReturnIsChangeHeader = () => {
	isChangeHeader.value = true;
};
const onClickNext = () => {
	showBtnNext.value && onNextUnit();
};
const onClickResult = () => {
	showBtnResult.value && onFinish();
};
</script>

<style scoped lang="scss">
p {
	margin-bottom: 0;
	line-height: inherit;
}
.word-chart_item {
	padding: 0px 20px;
	text-align: center;
}

.q-dialog__backdrop {
	width: 100vw;
	height: 100vh;
	top: 0px;
	position: fixed;
	z-index: 6000;
	pointer-events: all;
	outline: 0;
	background: rgb(23 20 20 / 40%);
}

.color_red {
	color: #ff4e7c;
}

.color_normal {
	color: #8e8e8e;
}

.progressNormal {
	color: #8e8e8e;
}

.progressWarn {
	color: #ff4e7c;
}

button:disabled,
button[disabled] {
	// border: 1px solid #999999;
	background-color: #cccccc;
	color: #666666;
}

button {
	background-color: #00a2e0;
	color: #fff;
}

.transparent {
	background-color: transparent;
}

.mmSelected {
	background-color: #cbcbcb;
}

.black {
	background-color: #000;
}

::v-deep {
	.q-toolbar {
		display: block;
		min-height: inherit;
		margin: 1.58vmin 0;
		padding: 0 3.33vmin;

		.display_flex {
			align-items: center;
		}

		.q-icon {
			display: inline-block;
			width: 2.4vw;
			height: 2.4vw;
			padding: 0.33vmin 0.42vmin;
			box-sizing: border-box;
		}
	}

	.answer {
		&--next {
			.q-icon {
				margin: 0 auto;
				font-size: 1.3vw;
			}
		}

		&--prev {
			.q-icon {
				margin: 0 auto;
				font-size: 1.3vw;
			}
		}
	}
	.q-scrollarea__bar--v,
	.q-scrollarea__thumb--v {
		width: 0.3vw;
	}
}

.timer {
	position: absolute;
	top: 50%;
	left: 50%;
	@include transform(translate(-50%, -50%));
}

.passage,
.answer {
	//height: calc((var(--vh, 1vh) * 100) - 70px);
	height: calc((var(--vh, 1vh) * 100) - 70px);
	margin-top: 1.99vmin;
}
.passage {
	+ .answer {
		max-width: 50%;

		&::before {
			content: '';
			position: absolute;
			top: 46%;
			left: 0;
			width: 1px;
			height: 91%;
			max-height: 974px;
			background: $color_gray_500;
			@include transform(translateY(-50%));
		}
	}
}

.answer {
	position: relative;
	// padding: 0 4.17vmin;

	&__scroll {
		padding: 0 5.17vmin 3.33vmin 4.08vmin;
		// padding-right: 5.17vmin;
		// padding-bottom: 3.33vmin;
	}

	&--next {
		width: 4.9vw;
		height: 4.9vw;
		margin-right: 3.33vmin;
	}

	&--prev {
		width: 3.5vmin;
		height: 3.5vmin;
		margin-left: 2.5vmin;
	}

	&--submit {
		padding: 2.75vmin 3.42vmin !important;
		margin-right: 3.33vmin;
		font-size: 1.2vw;
		font-weight: 700;
		line-height: 1.6vw;
	}
}
</style>
